export default "__VITE_ASSET__BcITlL3B__"